export function PlayIcon(props) {
  return (
    <svg
      width={props?.width ? props?.width : '22'}
      height={props?.height ? props?.height : '22'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="11" fill="black" fillOpacity="0.4" />
      <path d="M17 10.5L8 15.2631L8 5.73686L17 10.5Z" fill="white" />
    </svg>
  );
}
